import { cn } from "../../utils/utils"

/**
 * The placeholder surface itself. Shared so an INLINE bar — `SkeletonText`
 * renders a `<span>`, because text placeholders sit inside `<p>`, headings,
 * labels and buttons where a `<div>` is invalid nesting — matches the block one
 * exactly instead of carrying a second copy of these classes.
 */
export const skeletonSurface = "bg-accent motion-safe:animate-pulse rounded-md"

/**
 * The one placeholder primitive every skeleton shape is built from.
 *
 * The pulse is `motion-safe:` so a viewer who asked the OS for reduced motion
 * gets a still, tinted block — still visibly a placeholder, nothing moving.
 * Every loading state in the product now resolves to a skeleton, so this is
 * the single place that promise has to be kept.
 */
function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn(skeletonSurface, className)}
      {...props}
    />
  )
}

export { Skeleton }
